import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import {  IoIosArrowForward } from "react-icons/io";

import { Link } from "react-router-dom";


function CategoryTree({categories,showCategory}) {
  
 
    

  const [expandedCategoryIds, setExpandedCategoryIds] = useState([]);

  const handleCategoryClick = (categoryId) => {
    if (expandedCategoryIds.includes(categoryId)) {
      // If the clicked category is already expanded, collapse it
      setExpandedCategoryIds(
        expandedCategoryIds.filter((id) => id !== categoryId)
      );
    } else {
      // Expand the clicked category
      setExpandedCategoryIds([...expandedCategoryIds, categoryId]);
    }
  };

  const renderCategories = (categories) => {
    return (
      <div   className=" text-black ">
        {categories.map((category) => (
          <div key={category.id}  
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
         
          >
          
               <div    className="cursor-pointer  pt-2 pb-2 flex justify-between items-center border-b-2 border-gray-100 z-50">
            <div
           
            className="ml-2 font-serif text-gray-600"
            onClick={showCategory}
              >
                  
                 <Link to={`/products/${category.id}`}>{category.name}</Link> 
              
            
            </div>
            <div>
            {expandedCategoryIds.includes(category.id) ? (
            
   <IoIosArrowForward className="transition-all duration-500 ease-in-out -rotate-380"  onClick={() => handleCategoryClick(category.id)} />


  ) : (
    category.children.length>0?
  <IoIosArrowForward className="transition-all duration-500 ease-in-out rotate-90"  onClick={() => handleCategoryClick(category.id)}/>
  :''
)}
            
            </div></div> 
            
            <AnimatePresence>
            {expandedCategoryIds.includes(category.id) &&
              category.children.length > 0 && (
          
                <motion.div    initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.3 }}
                className="pl-5"
               >
                  {renderCategories(category.children)}
                </motion.div>
               

              )} </AnimatePresence>
          </div>
        ))}
      </div>
    );
  };

  return <div>
   
    {renderCategories(categories)}
    
    
    </div>;
}

export default CategoryTree;
